import Hero from "@/components/sections/Hero";
import Seo from "@/components/seo/Seo";

const HOME_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": ["Organization", "ProfessionalService"],
    "@id": "https://www.kbconsultoria.com/#organization",
    name: "KB Consultoría",
    url: "https://www.kbconsultoria.com/",
    logo: "https://www.kbconsultoria.com/kb-logo.png",
    image: "https://www.kbconsultoria.com/og-kb-consultoria.jpg",
    description: "Consultoría, implementación y auditoría de sistemas de gestión ISO en Costa Rica y Centroamérica.",
    areaServed: [{ "@type": "Country", name: "Costa Rica" }, { "@type": "Place", name: "Centroamérica" }],
    address: { "@type": "PostalAddress", addressCountry: "CR", addressRegion: "San José" },
    contactPoint: { "@type": "ContactPoint", contactType: "customer service", email: "contacto@kbconsultoria.com", availableLanguage: "Spanish" },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://www.kbconsultoria.com/#website",
    url: "https://www.kbconsultoria.com/",
    name: "KB Consultoría",
    publisher: { "@id": "https://www.kbconsultoria.com/#organization" },
    inLanguage: "es-CR",
  },
];
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Marquee from "@/components/sections/Marquee";
import Clients from "@/components/sections/Clients";
import Methodology from "@/components/sections/Methodology";
import Normas from "@/components/sections/Normas";
import CasesPreview from "@/components/sections/CasesPreview";
import Benefits from "@/components/sections/Benefits";
import Sectors from "@/components/sections/Sectors";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Resources from "@/components/sections/Resources";
import CTA from "@/components/sections/CTA";
import Contact from "@/components/sections/Contact";
import featureFlags from "@/config/featureFlags.json";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Seo title="KB Consultoría — Sistemas de gestión, ISO y sostenibilidad" description="Consultoría, implementación y auditoría de sistemas de gestión ISO en Costa Rica y Centroamérica. Soluciones prácticas orientadas a resultados." path="/" structuredData={HOME_SCHEMA} />
      <Hero />
      <Clients />
      <About />
      <Marquee />
      <Services />
      <Methodology />
      <Normas />
      {featureFlags.showSuccessCases && <CasesPreview />}
      <Benefits />
      <Sectors />
      <Testimonials />
      <FAQ />
      <Resources />
      <CTA />
      <Contact />
    </main>
  );
}
